import { Directive, ElementRef, AfterViewInit } from '@angular/core';
import { LayoutService } from '../layout.service';

@Directive({ selector: '[myOpenSearchOverlay]' })

export class OpenSearchOverlaylDirective implements AfterViewInit {

  constructor(private el: ElementRef, private layoutService: LayoutService) {}

  ngAfterViewInit() {
    const $el = $(this.el.nativeElement);
    const $body = $('#body');

    $el.on('click', (e) => {
      this.openOverlay();
    });
  }

  openOverlay() {
    this.layoutService.updateSearchOverlayState('open');
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/layout/search-overlay/open-search-overlay.directive.ts